export const USER_ROLES = ['super_admin', 'admin', 'operator', 'viewer'];
/** De onde veio uma importação: upload no painel ou anexo lido da caixa de e-mail. */
export const IMPORT_SOURCES = ['manual', 'email'];
/**
 * Estado de uma importação.
 * - `active`: entra nos relatórios.
 * - `superseded`: substituída por outra importação do mesmo período (fica como histórico).
 * - `conflict`: chegou pela caixa de e-mail e o período dela cruza com uma importação ativa de
 *   período diferente; aguarda alguém decidir no painel (substituir ou excluir).
 */
export const IMPORT_STATUSES = ['active', 'superseded', 'conflict'];
/** Métricas que o painel mostra nas matrizes mensal e diária. */
export const REPORT_METRICS = ['gross', 'net'];
// ---------- Auditoria ----------
export const AUDIT_ACTIONS = [
    'create',
    'update',
    'delete',
    'import',
    'merge',
    'sync',
    'login',
    'login_failed',
    'logout',
    'account_locked',
    'token_reuse',
    'password_change',
    'password_reset',
    'sessions_revoked',
];
export const AUDIT_ENTITIES = [
    'auth',
    'user',
    'role',
    'affiliate',
    'product',
    'import',
    'settings',
];
